import React, { useContext, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faBell,
	faCog,
	faEnvelopeOpen,
	faSearch,
	faSignOutAlt,
	faUser,
	faUserShield,
} from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
import {
	Row,
	Col,
	Nav,
	Form,
	Image,
	Navbar as TemplateNavbar,
	Dropdown,
	Container,
	ListGroup,
	InputGroup,
} from "@themesberg/react-bootstrap";

import { AuthContext } from "src/app/contexts/AuthContext";
import { AUTH_REDUCER_REMOVE_AUTH_DATA } from "src/app/common/constants";

const Navbar = (props) => {
	// Notification operation
	// const [notifications, setNotifications] = useState([
	// 	{
	// 		id: 1,
	// 		read: false,
	// 		sender: "Jose Leos",
	// 		time: "a few moments ago",
	// 		link: "#",
	// 		message: `Added you to an event "Project stand-up" tomorrow at 12:30 AM.`,
	// 	},
	// 	{
	// 		id: 2,
	// 		read: false,
	// 		sender: "Neil Sims",
	// 		time: "2 hrs ago",
	// 		link: "#",
	// 		message: `You've been assigned a task for "Awesome new project".`,
	// 	},
	// ]);
	// const areNotificationsRead = notifications.reduce((acc, notif) => acc && notif.read, true);

	// const markNotificationsAsRead = () => {
	// 	setTimeout(() => {
	// 		setNotifications(notifications.map((n) => ({ ...n, read: true })));
	// 	}, 300);
	// };

	// const Notification = (props) => {
	// 	const { link, sender, image, time, message, read = false } = props;
	// 	const readClassName = read ? "" : "text-danger";

	// 	return (
	// 		<ListGroup.Item action href={link} className="border-bottom border-light">
	// 			<Row className="align-items-center">
	// 				<Col className="col-auto">
	// 					<FontAwesomeIcon
	// 						icon={faUser}
	// 						className="user-avatar sm-avatar rounded-circle"
	// 						style={{ color: "#262b40" }}
	// 					/>
	// 				</Col>
	// 				<Col className="ps-0 ms--2">
	// 					<div className="d-flex justify-content-between align-items-center">
	// 						<div>
	// 							<h4 className="h6 mb-0 text-small">{sender}</h4>
	// 						</div>
	// 						<div className="text-end">
	// 							<small className={readClassName}>{time}</small>
	// 						</div>
	// 					</div>
	// 					<p className="font-small mt-1 mb-0">{message}</p>
	// 				</Col>
	// 			</Row>
	// 		</ListGroup.Item>
	// 	);
	// };

	//AuthContext operation
	const { authData, dispatch } = useContext(AuthContext);

	const handleLogOut = () => {
		dispatch({ type: AUTH_REDUCER_REMOVE_AUTH_DATA });
	};

	return (
		<TemplateNavbar variant="dark" expanded className="ps-0 pe-2 pb-0">
			<Container fluid className="px-0">
				<div className="d-flex justify-content-between w-100">
					<div className="d-flex align-items-center">
						{/* Search bar */}
						{/* <Form className="navbar-search">
							<Form.Group id="topbarSearch">
								<InputGroup className="input-group-merge search-bar">
									<InputGroup.Text>
										<FontAwesomeIcon icon={faSearch} />
									</InputGroup.Text>
									<Form.Control type="text" placeholder="Search" />
								</InputGroup>
							</Form.Group>
						</Form> */}

						{/* Notification */}
						{/* <Dropdown as={Nav.Item} onToggle={markNotificationsAsRead}>
							<Dropdown.Toggle
								as={Nav.Link}
								className="text-dark icon-notifications me-lg-3"
							>
								<span className="icon icon-sm">
									<FontAwesomeIcon icon={faBell} className="bell-shake" />
									{areNotificationsRead ? null : (
										<span className="icon-badge rounded-circle unread-notifications" />
									)}
								</span>
							</Dropdown.Toggle>
							<Dropdown.Menu className="dashboard-dropdown notifications-dropdown dropdown-menu-lg dropdown-menu-center mt-2 py-0">
								<ListGroup className="list-group-flush">
									<Nav.Link
										href="#"
										className="text-center text-primary fw-bold border-bottom border-light py-3"
									>
										Notifications
									</Nav.Link>

									{notifications.map((n) => (
										<Notification key={`notification-${n.id}`} {...n} />
									))}

									<Dropdown.Item className="text-center text-primary fw-bold py-3">
										View all
									</Dropdown.Item>
								</ListGroup>
							</Dropdown.Menu>
						</Dropdown> */}
					</div>
					<Nav className="align-items-center">
						{/* Profile Icon and menu */}
						<Dropdown as={Nav.Item}>
							<Dropdown.Toggle as={Nav.Link} className="pt-1 px-0">
								<div className="media d-flex align-items-center">
									<FontAwesomeIcon
										icon={faUser}
										className="card-img-top rounded-circle border-white"
										style={{ fontSize: "20px", color: "#262b40" }}
									/>
									<div className="media-body ms-2 text-dark align-items-center d-none d-lg-block">
										<span className="mb-0 font-small fw-bold">
											{authData?.user_data?.name}
										</span>
									</div>
								</div>
							</Dropdown.Toggle>
							<Dropdown.Menu className="user-dropdown dropdown-menu-right mt-2">
								{/* <Dropdown.Item className="fw-bold">
									<FontAwesomeIcon icon={faUserCircle} className="me-2" /> My
									Profile
								</Dropdown.Item>
								<Dropdown.Item className="fw-bold">
									<FontAwesomeIcon icon={faCog} className="me-2" /> Settings
								</Dropdown.Item>
								<Dropdown.Item className="fw-bold">
									<FontAwesomeIcon icon={faEnvelopeOpen} className="me-2" />{" "}
									Messages
								</Dropdown.Item>
								<Dropdown.Item className="fw-bold">
									<FontAwesomeIcon icon={faUserShield} className="me-2" /> Support
								</Dropdown.Item>

								<Dropdown.Divider /> */}

								<Dropdown.Item className="fw-bold" onClick={() => handleLogOut()}>
									<FontAwesomeIcon
										icon={faSignOutAlt}
										className="text-danger me-2"
									/>{" "}
									Logout
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					</Nav>
				</div>
			</Container>
		</TemplateNavbar>
	);
};

export default Navbar;